import React from 'react';

import { IconProps } from '../../DefaultIcon';

export function ClientContractsIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="68"
      viewBox="0 0 80 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_4565)">
        <path
          d="M72.4 68V4.80005C72.4 3.20005 71 1.80005 69.4 1.80005H17C15.4 1.80005 14 3.20005 14 4.80005V60C14 64.4001 17.6 68 22 68H72.4Z"
          fill="#EAEEF9"
        />
        <path
          d="M22.2 68C26 68 29.2 65.2 29.8 61.4C29.8 60.8 30.4 60.4 31 60.4H78.8C79.6 60.4 80.2 61 80 61.8C79.4 65.4 76.2 68 72.4 68H22.2Z"
          fill="#00C4B3"
        />
        <path
          d="M7.6 6H2.2C1.2 6 0.400002 6.8 0.400002 7.8V56.2C0.400002 56.6 0.800002 57 1.4 57H8.6C9 57 9.6 56.6 9.6 56.2V7.8C9.4 6.8 8.6 6 7.6 6Z"
          fill="#EAEEF9"
        />
        <path
          d="M9.4 11.8H0.2C0.2 11.8 0 11.8 0 12V14.4C0 14.6 0.2 14.6 0.2 14.6H9.2C9.4 14.6 9.4 14.4 9.4 14.4V12C9.6 11.8 9.4 11.8 9.4 11.8Z"
          fill="#00416B"
        />
        <path
          d="M9.4 17.8H0.2C0.2 17.8 0 17.8 0 18V20.4C0 20.6 0.2 20.6 0.2 20.6H9.2C9.4 20.6 9.4 20.4 9.4 20.4V18C9.6 17.8 9.4 17.8 9.4 17.8Z"
          fill="#00416B"
        />
        <path
          d="M9.4 39H0.2C0 39 0 39.2 0 39.4V56.2C0 56.6 0.4 57.2 1 57.2H8.8C9.2 57.2 9.8 56.8 9.8 56.2V39.4C9.6 39.2 9.4 39 9.4 39Z"
          fill="#00416B"
        />
        <path
          d="M8.8 57H1L4 65.4C4.4 66.2 5.6 66.2 5.8 65.4L8.8 57Z"
          fill="#00C4B3"
        />
        <path
          d="M6 0H3.6C2.8 0 2.2 0.6 2.2 1.6V6H7.6V1.6C7.6 0.6 6.8 0 6 0Z"
          fill="#00C4B3"
        />
        <path
          d="M53.6 13.4H35.6C34.8 13.4 34.2 13 34.2 12.4C34.2 11.8 34.8 11.6 35.6 11.6H53.6C54.4 11.6 55 12 55 12.4C55 12.8 54.4 13.4 53.6 13.4Z"
          fill="#FBFCFE"
        />
        <path
          d="M66.6 18.8H50.4C49.6 18.8 49 18.4 49 18C49 17.6 49.6 17 50.4 17H66.6C67.4 17 68 17.4 68 18C68 18.6 67.4 18.8 66.6 18.8Z"
          fill="#FBFCFE"
        />
        <path
          d="M43.6 18.8H22.4C21.6 18.8 21 18.4 21 18C21 17.6 21.6 17 22.4 17H43.6C44.4 17 45 17.4 45 18C45 18.6 44.4 18.8 43.6 18.8Z"
          fill="#FBFCFE"
        />
        <path
          d="M66.6 24.2H41.8C41 24.2 40.4 23.8 40.4 23.2C40.4 22.6 41 22.4 41.8 22.4H66.6C67.4 22.4 68 22.8 68 23.2C68 23.6 67.4 24.2 66.6 24.2Z"
          fill="#FBFCFE"
        />
        <path
          d="M35.6 24.2H22.6C21.8 24.2 21.2 23.8 21.2 23.2C21.2 22.6 21.8 22.4 22.6 22.4H35.6C36.4 22.4 37 22.8 37 23.2C37 23.6 36.2 24.2 35.6 24.2Z"
          fill="#FBFCFE"
        />
        <path
          d="M42.8 29.6H22.4C21.6 29.6 21 29.2 21 28.8C21 28.4 21.6 27.8 22.4 27.8H42.8C43.6 27.8 44.2 28.2 44.2 28.8C44.2 29.4 43.6 29.6 42.8 29.6Z"
          fill="#FBFCFE"
        />
        <path
          d="M38.6 35H22.4C21.6 35 21 34.6 21 34C21 33.6 21.6 33.2 22.4 33.2H38.6C39.4 33.2 40 33.6 40 34C40 34.6 39.4 35 38.6 35Z"
          fill="#FBFCFE"
        />
        <path
          d="M42.8 40.4H22.4C21.6 40.4 21 40 21 39.4C21 38.8 21.6 38.4 22.4 38.4H42.8C43.6 38.4 44.2 38.8 44.2 39.4C44.2 40 43.6 40.4 42.8 40.4Z"
          fill="#FBFCFE"
        />
        <path
          d="M42.8 45.8H22.4C21.6 45.8 21 45.4 21 45C21 44.6 21.6 44 22.4 44H42.8C43.6 44 44.2 44.4 44.2 45C44.2 45.4 43.6 45.8 42.8 45.8Z"
          fill="#FBFCFE"
        />
        <path
          d="M33.8 51.2H22.6C21.8 51.2 21.2 50.8 21.2 50.2C21.2 49.6 21.8 49.4 22.6 49.4H33.8C34.6 49.4 35.2 49.8 35.2 50.2C35.2 50.6 34.4 51.2 33.8 51.2Z"
          fill="#FBFCFE"
        />
        <path
          d="M60.2 44.6L62.2 45.6C61.2 47.2 59.6 48.4 57.4 48.4C54.6 48.4 52.6 46.8 52 44.4H50L51 42.8H51.8C51.8 42.6 51.8 42.6 51.8 42.4V42.2H50L51 40.6H52C52.6 38.2 54.8 36.4 57.4 36.4C59.6 36.4 61.4 37.4 62.2 39.2L60.2 40.2C59.6 39.2 58.6 38.6 57.4 38.6C56 38.6 54.8 39.4 54.4 40.4H60L59 42H54V42.2C54 42.4 54 42.4 54 42.6H58.8L58 44.4H54.4C55 45.6 56 46.2 57.4 46.2C58.8 46.2 59.8 45.6 60.2 44.6Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_4565">
          <rect width="80" height="68" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
